import { props } from '@ngrx/store';
import { Component, Input, OnInit, ElementRef, ViewChild, OnChanges, SimpleChanges, ChangeDetectorRef, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, PopoverController } from '@ionic/angular';
import { Browser } from '@capacitor/browser';
import { StoreRedirectService } from '../../services/store-redirect.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'popover-delimitation-option.component',
  templateUrl: './popover-delimitation-option.component.html',
  styleUrls: ['./popover-delimitation-option.component.scss'],
})
export class PopoverDelimitaionOptionComponent implements OnInit, OnChanges {
  @Input() key1: string = '';
  @Input() alertMsg: string = '';
  @Input() canBeClosed: boolean = true;
  @Input() button_label: string = 'submit';
  @Input() is_confirm_needed: boolean = true;
  @Input() is_info_popover: boolean = true;
  @Input() is_loader_needed: boolean = false;
  @Input() progress = 0;
  @Input() totalOperations = 0;
  @Input() is_html_inner: boolean = false;
  @Input() confirmLink: string = '';
  @Input() delimitationPermitted: boolean = false;
  @Input() geolocationPermitted: boolean = false;
  @ViewChild('option-1') option1: ElementRef<HTMLButtonElement>;
  @ViewChild('option-2') option2: ElementRef<HTMLButtonElement>;
  @ViewChild('option-3') option3: ElementRef<HTMLButtonElement>;
  close;
  @Input() onConfirm: () => void;

  constructor(
    public popover: PopoverController,
    public router: Router,
    private platform: Platform,
    private storeRedirectService: StoreRedirectService,
    private popoverDataService: PopoverDataService

  ) { }
  props = {
    progress: 0,
    totalOperations: 0,
    completedOperations: 0
  }
  ngOnInit() {
    this.popoverDataService.inputData$.subscribe(props => {
      this.props = props;

      if (this.props.progress == 100) {
        this.popover.dismiss({ closed: true });
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  ngAfterViewInit(): void {
    if (this.is_html_inner) {
      if (this.delimitationPermitted) {
        document.getElementById('option-1')?.addEventListener('click', () => {
          this.ClosePopover('1');
        });
        document.getElementById('option-2')?.addEventListener('click', () => {
          this.ClosePopover('2');
        });
      } else {
        document.getElementById('option-1').style.opacity = '0.4';
        document.getElementById('option-1').style.cursor = 'default';

        document.getElementById('option-2').style.opacity = '0.4';
        document.getElementById('option-2').style.cursor = 'default';
      }

      document.getElementById('option-3')?.addEventListener('click', () => {
        this.ClosePopover('3');
      });
    }
  }
  async ClosePopover(option) {
    if (this.confirmLink) {
      if (this.platform.is('ios') || this.platform.is('android')) {
        localStorage.setItem('updateInProgress', 'true');
        await this.storeRedirectService.redirectToStore(
          '6450292879',
          'com.burrusdevelopmentgroup.fynka.app',
          this.confirmLink
        );
      }
      this.popover.dismiss({ closed: true, option: option });
      this.onConfirm();
    } else {
      this.popover.dismiss({ closed: true, option: option });
    }
  }
}


@Injectable({ providedIn: 'root' })
export class PopoverDataService {
  private inputDataSubject = new BehaviorSubject<any>(0);
  inputData$ = this.inputDataSubject.asObservable();

  updateInputData(props) {
    this.inputDataSubject.next(props);
  }
}